export const formatNumberToFixed = (num: number, decimals: number): string => {
  if (num === null || num === 0) return "0";
  return num.toFixed(decimals);
};

export const commarizeSimple = (num: string) => {
  if (typeof num !== "number") return num;
  let parsed: any = parseFloat(num);
  if (parsed % 1) {
    parsed = parsed.toFixed(3);
  }
  return parsed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const splitCamelCase = (inputString: string) =>
  inputString.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();

export const replaceStringTokens = (
  inputString: string,
  replaceToken: string,
  replaceString: string
) => {
  return inputString.replace(new RegExp(replaceToken, "g"), replaceString);
};

export const checkPropExistsAnyCase = (obj: any, prop: string) => {
  const fieldLower = prop.toLowerCase();
  return !!Object.keys(obj).find((x: string) => x.toLowerCase() === fieldLower);
};
